import React, { useState } from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';
import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useBattleCardsStore } from 'store/battlecards.store';
import { useProjectTreeStore } from 'store/projectContract.store';
import { useVersionStore } from 'store/version.store';

import { useQueryGetProgramGeneralHierarchyList } from 'api/queries/getProgramGeneralHierarchyList.query';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryResponse, useQueryVersionList } from 'api/queries/getVersionListByContractId.query';

import { TreeCrumbs } from 'components/common/TreeCrumbs/TreeCrumbs';

import MainUserImg from 'components/App/AuthenticateLayout/Header/MainUserImg/mainUserImg';
import UserMenu from 'components/App/AuthenticateLayout/Header/UserMenu/userMenu';
import classes from 'components/Mobile/components/header/header.module.scss';
import {
    getFilterPayloadAndUrlQueryString,
    getInitialFilterObj,
    notInSpecificPage,
} from 'components/Mobile/mobile.utils';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';

export const HeaderMobile = () => {
    const { update, contract } = useProjectTreeStore();
    const { data: projectHierarchyList } = useQueryGetProgramGeneralHierarchyList('ProgramLibraryMobile');
    const { setFilterData } = useBattleCardsStore();
    const [isMounted, setIsMounted] = useState(false);

    const history = useHistory();
    const pathnameLocation = window.location.pathname;
    const { setVersion, version } = useVersionStore();

    const { data } = useQueryVersionList({ ids: [-1], contractId: contract?.id });

    // When user changes contract then the filter resets to the default filter
    const onSelectionFinish = async ({ project, contract }) => {
        update({ project, contract });
        setIsMounted(false);
    };

    const setInitialVersion = (data: QueryResponse[] | undefined) => {
        // no version then go to "no version for contract" page

        if (data !== undefined && data.length === 0) {
            setVersion(null);
            history.replace(AppRoutes.buildPath(AppRoutes.MOBILE, mobileAppConfig.noDataFound.link));
            setIsMounted(true);
        } else if (data !== undefined && data.length > 0) {
            const latestVersion = data[0];
            latestVersion['id'] = latestVersion.versionDbId;
            setVersion(latestVersion as IVersion);
            if (location.pathname.includes(mobileAppConfig.home.link)) {
                const newPath = AppRoutes.buildPath(
                    AppRoutes.MOBILE,
                    mobileAppConfig.home.link,
                    latestVersion.versionHashCode,
                );
                history.push(newPath);
            }
            if (location.pathname.includes(mobileAppConfig.activities.link)) {
                let newPath = AppRoutes.buildPath(
                    AppRoutes.MOBILE,
                    mobileAppConfig.activities.link,
                    latestVersion.versionHashCode,
                );
                if (location.pathname.includes('card-')) {
                    const cardId = location.pathname.split('card-')[1];
                    newPath = `${newPath}/card-${cardId}`;
                }

                const filter = getInitialFilterObj({
                    projectId: latestVersion.projectId,
                    contractId: latestVersion.contractId,
                    versionId: latestVersion.id,
                });
                const { filterPayload, querystring } = getFilterPayloadAndUrlQueryString(filter);
                setFilterData(filterPayload);
                history.push({
                    search: querystring,
                    pathname: newPath,
                });
            }
            setIsMounted(true);
        }
    };

    if (!isMounted) {
        setInitialVersion(data);
    }

    const isNotificationPage = notInSpecificPage(pathnameLocation, mobileAppConfig.notifications.link);
    const latestVersionNameSubTitle = version
        ? `Latest Version: ${version.versionName} (${moment(version.versionDate).format(constants.formats.date.default)})`
        : '';

    return (
        <div className={classes.mobileHeader}>
            <div className={classes.title}>
                {!isNotificationPage && contract && projectHierarchyList && (
                    <>
                        <div className={classes.treeCrumbsSection}>
                            <TreeCrumbs
                                selectedNode={contract.uuid}
                                onSelectionFinish={onSelectionFinish}
                                data={projectHierarchyList}
                                showAddNewButton={false}
                            />
                        </div>
                        {version && <div className={classes.latestVersionSubTitle}>{latestVersionNameSubTitle}</div>}
                    </>
                )}
            </div>
            <div data-testid={'user-image'} className={classes.userImg}>
                <MainUserImg showImg={false} />
                <UserMenu />
            </div>
        </div>
    );
};
